import React, {Component, Fragment} from 'react';
import { NavLink } from 'react-router-dom';

import './favorites.scss';

import * as routes from '../../../../../constants/routes';

import Slider from 'react-slick';
import VehicleCard from '../../../../../components/forms/vehicle_card/vehicleCard.js';
import favCounter from 'assets/icons/favorites_counter.svg';
import {connect} from "react-redux";
import {getFullMediaUrl, getLocalStorageItem} from "../../../../../app/static_func";
import * as keys from "../../../../../constants/storage-keys";
import {getFavoriets} from "../../../../../redux/actions";


class Favorites extends Component{

    componentDidMount(){
        if (JSON.parse(getLocalStorageItem(keys.FAVORITES)) === null){
            this.props.getCar({licenseNumbers: 0})
        }
        else
            this.props.getCar({licenseNumbers: JSON.parse(getLocalStorageItem(keys.FAVORITES))});
    }

    getFavorites(){
        const data = this.props.carDetails;

        let res = [];

        let i = 0;


        for(let key in data){

            if (i === 3)
                break;

            let mainPhoto = null;

            if (data[key] !== null){
                mainPhoto = data[key].images.filter(item =>{
                    return item['is-main-image'];
                });
            }

            if (data[key] !== null) {
                res.push(<div className='oneCard' key={i}>
                        <VehicleCard id={data[key]['license-number']}
                                     model={data[key].year + ' ' + data[key].manufacturer + ' ' + data[key].model}
                                     subModel={data[key].submodel}
                                     km={data[key]['important-info'].km.value}
                                     price={data[key].price}
                                     grade={parseFloat(data[key]['important-info']['peeps-scroe'].value !== null ? data[key]['important-info']['peeps-scroe'].value : '8.2') * 10}
                                     displayPhoto={getFullMediaUrl(mainPhoto[0].image.path)}
                                     licenseNum={data[key]['license-number']}
                                     history={this.props.history}
                        />
                    </div>
                );

                i++;
            }
        }

        return res;
    }

    render(){

        const isMobile = this.props.deviceState === 'mobile';
        const isTablet = this.props.deviceState === 'tablet';
        const isLaptopOrDesktop = (!isMobile && !isTablet);

        const carDetails = this.props.carDetails;


        const hasFavorites = this.getFavorites().length > 0;

        let slidesToShow = 0;

        let initialSlide = 0;

        if(isMobile){
            slidesToShow = 1.3;
            initialSlide = 2;
        }

        else if(isTablet) {
            slidesToShow = 2.5;
            initialSlide = 0.5;
        }

        else
            slidesToShow = 3;

        const settings = {
            dots: false,
            infinite: false,
            speed: 500,
            slidesToShow: slidesToShow,
            slidesToScroll: 1,
            rtl:true,
            initialSlide:initialSlide,
            arrows:false
        };


        const num = this.getFavorites().length;

        return(
            <section className='favorites'>
                {hasFavorites && carDetails &&
                <Fragment>
                    <div className='wrapper'>
                        <div className='titleContainer'>
                            {!isLaptopOrDesktop &&
                            <Fragment>
                                <h2 className='title'>רכבים שאהבת </h2>
                                <div className='counter'>
                                    <img src={favCounter} alt='\' className='favCounter'/>
                                    <span className='count'>{num}</span>
                                </div>
                                <div className='divider'/>
                            </Fragment>
                            }
                            {isLaptopOrDesktop && carDetails &&
                            <div className='withDivider'>
                                <div className='titleDiv'>
                                    <h2 className='title'>רכבים שאהבת</h2>
                                    <div className='counter'>
                                        <img src={favCounter} alt='\' className='favCounter'/>
                                        <span className='count'>{num}</span>
                                    </div>
                                </div>
                                <div className='divider'/>
                            </div>
                            }
                        </div>
                        {!isLaptopOrDesktop && carDetails &&
                        <Slider {...settings} className='lovedOnes'>
                            {this.getFavorites()}
                        </Slider>
                        }

                        {isLaptopOrDesktop && carDetails &&
                        <Fragment>
                            <div className='desktop'>
                                {this.getFavorites()}
                            </div>
                        </Fragment>
                        }
                        {!isLaptopOrDesktop && carDetails &&
                        <span className='allCars'>לכל הרכבים שאהבת לאחרונה</span>
                        }
                    </div>
                    {isLaptopOrDesktop && carDetails &&
                    <div className="buttons sec-ent">
                        <NavLink to={routes.placeholder} className="match">מצא לי התאמה</NavLink>
                        <NavLink to={routes.results} className="search_btn"> צפו בכל הרכבים
                        </NavLink>
                    </div>
                    }
                </Fragment>
                }
            </section>
        )
    }
}

//add GD categories and deviceState to props
const mapStateToProps = store => {
    return {
        deviceState: store.state.deviceState,
        carDetails: store.data.Favorites
    }
}
//map a doLgin function to props
const mapDispatchToProps = dispatch => {
    return {
        getCar: (payload) => dispatch(getFavoriets(payload)),
    }
}

//connect to redux store - maps dispatch and redux state to props
export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(Favorites);
